<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">心理课堂</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #cover="{ row }">
            <img
              v-if="row.cover"
              :src="row.cover"
              alt=""
              class="cover_img"
              @click="click_cover(row.cover)"
            />
          </template>
          <template #courseListCount="{ row }">
            {{ `共${row.courseListCount}讲` }}
          </template>
          <template #type="{ row }">
            {{ row.type === 0 ? "视频" : "图文" }}
          </template>
          <template #isPutaway="{ row }">
            {{ row.isPutaway ? "已上架" : "已下架" }}
          </template>
          <template #handler="{ row }">
            <MyButton icon="View" link @click="click_view(row)">查看</MyButton>
            <MyButton icon="Edit" link @click="click_edit(row)">编辑</MyButton>
            <ConfirmButton icon="Delete" link @confirm="click_delete(row)" :hint="`是否确认删除《${row.name}》？`" type="error">删除</ConfirmButton>
            <ConfirmButton v-if="!row.isPutaway" icon="Unlock" link @confirm="click_switch(row)" :hint="`是否确认上架《${row.name}》？`" >上架</ConfirmButton>
            <ConfirmButton v-else icon="Lock" link @confirm="click_switch(row)" :hint="`是否确认下架《${row.name}》？`" >下架</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :total="total" :params="getListParams" @get-list="getList" ref="pagination" />
      </div>
    </div>
    <!-- 新增 -->
    <Dialog
      v-model="addVisible"
      :title="titleAdd"
      top="5vh"
      width="50%"
      @closed="resetForm"
    >
      <el-form
        :model="formData"
        label-width="auto"
        :rules="rules"
        ref="formRef"
        class="form"
      >
        <el-form-item label="课程名称：" prop="name" :class="{'from-readonly': readonly}">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="所属专区：" prop="areaKeyId" :class="{'from-readonly': readonly}">
          <el-select v-model="formData.areaKeyId" @change="(val) => formData.areaKeyName = val && areaList.find(item=>item.value === val).name">
            <el-option v-for="item in areaList" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程分类：" prop="keyId" :class="{'from-readonly': readonly}">
          <el-select v-model="formData.keyId" @change="(val) => formData.keyName = val && typeList.find(item=>item.value === val).name">
            <el-option v-for="item in typeList" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程封面图：" prop="cover" :class="{'from-readonly': readonly}">
          <ImgUpload v-model="formData.cover" />
          <div class="tip" style="margin-left: 20px;">(建议上传690*150px的图片)</div>
        </el-form-item>
        <el-form-item label="课程介绍：" prop="remarks">
          <el-input type="textarea" v-model="formData.remarks" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="课程类型：" prop="type" :class="{'from-readonly': readonly}">
          <el-radio-group v-model="formData.type">
            <el-radio :value="0">视频</el-radio>
            <el-radio :value="1">图文</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="40" :class="{'from-readonly': readonly}">
          <el-col :span="10">
            <el-form-item label="课程价格：" prop="price">
              <el-input v-model="formData.price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="排序：" prop="sort">
              <el-input v-model="formData.sort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 视频上传区域 -->
        <el-form-item
          v-if="formData.type == 0"
          label="课程信息："
          prop="courseList"
          :class="{'from-readonly': readonly}"
        >
          <!-- 动态生成的课程信息项 -->
          <div class="course-info">
            <el-row :gutter="5" v-for="(item, index) in formData.courseList" class="course-infoItem">
              <el-col :span="9" class="infoItem-left">
                <div style="flex-shrink: 0;">第{{ index + 1 }}节标题</div>
                <el-input v-model="item.name"></el-input>
              </el-col>
              <el-col :span="15" class="infoItem-right">
                <template v-if="!item.id">
                  <div v-if="!item.fileList.length" style="flex-shrink: 0;">上传视频</div>
                  <el-upload
                    class="video-upload"
                    v-model:file-list="item.fileList"
                    accept=".mp4,.avi"
                    ref="uploadRef"
                    action="#"
                    :limit="1"
                    :http-request="(fileInfo)=>httpRequest(fileInfo,item)"
                  >
                    <div class="upload-box" v-if="!item.fileList.length" ref="uploadBoxEl">
                      <SvgIcon name="upload" size="20px"></SvgIcon>
                    </div>
                  </el-upload>
                </template>
                <div style="cursor: pointer;flex-shrink: 0;margin-left: 40px;" @click="clearCourseInfo(index)">清空</div>
              </el-col>
            </el-row>
            <MyButton icon="Plus" @click="addCourseInfo">添加课程</MyButton>
          </div>
        </el-form-item>

        <!-- 富文本编辑器 -->
        <el-form-item label="课程信息：" prop="content" v-if="formData.type == 1">
          <RichText
            v-model="formData.content"
            style="height: 350px;"
            @uploadFile="editorUploadFile"
            ref="editorRef"
            :readonly="readonly"
          />
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
    <!-- 图片预览 -->
    <Dialog v-model="dialogImgVisible" title="图片预览" top="5vh">
      <img :src="dialogImageUrl" alt="Preview Image" style="width: 100%" />
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyButton from "@/components/Global/MyButton.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import ImgUpload from "@/components/Common/ImgUpload.vue";
import RichText from "@/components/RichText.vue";
import uploadApi from "@/api/upload.js";
import { ref, reactive } from "vue";
import courseApi from "@/api/course.js";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
import dictionary from "@/api/dict.js";
import { cloneDeep } from "lodash-es";

const dialogImgVisible = ref(false); //预览图片dialog
const dialogImageUrl = ref(""); //预览图片地址
// 图片预览
const click_cover = (url) => {
  dialogImageUrl.value = url;
  dialogImgVisible.value = true;
};
const titleAdd = ref("新增");
// 搜索
// 分类列表
const typeList = ref([]);
const getTypeList = () => {
  dictionary.getList('course').then((res) => {
    typeList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    });
  })
}
getTypeList();
//所属专区
const areaList = ref([]);
const getAreaList = () => {
  dictionary.getList('areacourse').then((res) => {
    areaList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    });
  })
}
getAreaList();
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "课程名称：",
      prop: "name",
      attrs: {
        placeholder: "请输入课程名称",
      }
    },
    {
      type: "Select",
      label: "课程分类：",
      prop: "keyId",
      options: typeList,
      attrs: {
        placeholder: "请选择",
      },
      events: {
        click(formData,formRef,val) {
          if(!val){
            return
          }
          formData.keyName = typeList.value.find(item=>item.value === val).name
        },
      },
    },
    {
      type: "Select",
      label: "是否上架：",
      prop: "isPutaway",
      options:[
        {label: "已上架", value: true},
        {label: "已下架", value: false},
      ],
      attrs: {
        placeholder: "请选择",
      }
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(getListParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          readonly.value = false;
          addVisible.value = true;
          titleAdd.value = "新增";
        },
      },
    },
  ],
});
// 分页
const pagination = ref();
const total = ref(0);
const getListParams = reactive({
  
})
const getList = (params = pagination.value.getList_Params) => {
  courseApi.getList(params).then((res) => {
    tableOptions.tableData = res.data.items.map(item=>{
      item.creationTime = dayjs(item.creationTime).format('YYYY-MM-DD')
      return item
    });
    total.value = res.data.totalCount;
  })
}
// 表格
const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "课程名称", prop: "name" },
    { label: "课程分类", prop: "keyName" },
    { label: "课程类型",type:'slot', slot_name: "type" },
    { type: "slot", label: "课程封面图", slot_name: "cover",minWidth: 100 },
    { label: "课程纲目", slot_name: "courseListCount" },
    { label: "上架状态", type:'slot', slot_name: "isPutaway" },
    { label: "上架时间", prop: "creationTime" },
    { label: "价格", prop: "price" },
    { label: "排序", prop: "sort" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});

// 新增
const addVisible = ref(false);

const rules = {
  name: [{ required: true, message: "请输入课程名称", trigger: "blur" }],
  areaKeyId: [
    { required: true, message: "请选择所属专区", trigger: "change" },
  ],
  keyId: [
    { required: true, message: "请选择课程分类", trigger: "change" },
  ],
  price: [
    { required: true, message: "请输入课程价格", trigger: "blur" },
    {
      pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
      message: "价格格式不正确",
      trigger: "blur",
    },
  ],
  sort: [
    { required: true, message: "请输入排序", trigger: "blur" },
    { pattern: /^[0-9]+$/, message: "排序必须是数字", trigger: "blur" },
  ],
};

const formData = ref({
  type: 0,
  courseList: [],
});

// 新增心理测评 确认按钮
const formRef = ref(null);
const resetForm = () => {
  formRef.value.resetFields();
  formData.value = {
    type: 0,
    courseList: [],
  };
}
const click_confirm = () => {
  console.log(formData.value);
  if(readonly.value){
    addVisible.value = false;
    return
  }
  formRef.value.validate(async (valid) => {
    if (valid) {
      let res = formData.value.id ? await courseApi.editCourse(formData.value)
      : await courseApi.addCourse(formData.value)
      await saveVideos(res.data.id);
      if(clearCourseList.value.length){
        console.log(clearCourseList.value);
        
        Promise.all(clearCourseList.value.map(item => {
          return courseApi.delCourseList(item)
        })).finally(()=>{
          clearCourseList.value = [];
        })
      }
      ElMessage.success(`${formData.value.id ? '编辑' : '新增'}成功`);
      addVisible.value = false;
      getList();
    }
  })
};
const readonly = ref(false);
const click_view = async(row) => {
  readonly.value = true;
  titleAdd.value = "查看";
  let res = await courseApi.getCourseList({
    CourseId: row.id,
  })
  row.courseList = res.data.items;
  formData.value = cloneDeep(row);
  addVisible.value = true;
}
// 编辑
const click_edit = async(row) => {
  readonly.value = false;
  titleAdd.value = "编辑";
  let res = await courseApi.getCourseList({
    CourseId: row.id,
  })
  row.courseList = res.data.items;
  formData.value = cloneDeep(row);
  addVisible.value = true;
};
const click_switch = (row) => {
  row.isPutaway = !row.isPutaway;
  courseApi.editCourse(row).then(() => {
    ElMessage.success("操作成功");
    getList();
  })
}

const saveVideos = async(courseId) => {
  await Promise.all(formData.value.courseList.filter(item => !item.id).map(async (item) => {
    return courseApi.addCourseList({ 
      courseId,
      name: item.name,
      videoLibraryId: item.videoLibraryId,
    })
  }))
}

// 文件上传的钩子
const httpRequest = async (fileInfo,item) => {
  const F = new FormData();
  const { file } = fileInfo;
  F.append("file", file);
  let res = await uploadApi.UploadFile(F);
  const { id, fileName } = res.data;
  courseApi.bindVideo({ fileDataId: id, name: fileName }).then((res) => {
    item.videoLibraryId = res.data.id;
  })
};

// 添加课程项
const addCourseInfo = () => {
  formData.value.courseList.push({
    courseId: "",
    name: "",
    fileList: [],
  });
};

// 清空课程信息
const clearCourseList = ref([])
const clearCourseInfo = (index) => {
  ElMessageBox.confirm("确定要清空该课程信息吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: 'warning',
  }).then(()=>{
    let item = formData.value.courseList.splice(index, 1)[0];
    item.id && clearCourseList.value.push(item.id);
  })
};

// 富文本上传文件钩子
const editorUploadFile = async (file, insertFn) => {
  const F = new FormData();
  F.append("file", file);
  let res = await uploadApi.UploadFile(F);
  const { fullFileUrl, fileName } = res.data;
  insertFn(fullFileUrl, fileName);
};

// 删除模态框
const click_delete = (row) => {
  courseApi.delCourse(row.id).then(() => {
    ElMessage.success("删除成功");
    getList();
  })
};

</script>

<style lang="scss" scoped>
.form{
  padding: 20px 60px;
}
.container {
  .cover_img {
    width: 100px;
    height: 70px;
    border-radius: 8px;
    cursor: pointer;
  }
  .delete {
    margin-bottom: 40px;
    img {
      width: 60px;
      height: 60px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
:deep(){
  .course-info{
    width: 100%;
  }
  .course-infoItem {
    // width: 100%;
    // display: flex;
    // align-items: center;
    // gap: 10px;
    margin-bottom: 20px;
  }
  .infoItem-left {
    display: flex;
    align-items: center;
    gap: 10px;
    .el-input{
      width: 300px;
    }
  }
  .infoItem-right {
    display: flex;
    align-items: center;
    gap: 10px;
    .video-upload,.upload-box{
      height: 100%;
      display: flex;
      align-items: center;
      flex: 1;
      gap: 5px;
    }
    .el-upload-list {
      margin: 0;
      flex: 1;
    }
    .el-upload-list__item {
      margin: 0;
      padding: 0;
    }
  }
}
</style>
